import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { usePermission } from '@/hooks/usePermission'
import { DocDrawer } from './DocDrawer'
import { CircleHelp } from 'lucide-react'
import { DOCS_TOC } from '@/data/docs-toc'

type Props = {
  section: string
}

const ROUTE_MAP: Record<string, string> = {
  '/monitoring': 'admin_guide/01_monitoring',
  '/admin/users': 'admin_guide/02_users',
  '/admin/license': 'admin_guide/03_license',
  '/audit': 'admin_guide/04_audit',
  '/admin/sessions': 'admin_guide/05_sessions',
  '/admin/system': 'admin_guide/06_settings',
  '/settings': 'user_guide/02_getting_started',
  '/catalog': 'user_guide/03_projects',
  '/shared': 'user_guide/03_projects',
}

export function DocHint({ section }: Props) {
  const [open, setOpen] = useState(false)
  const entry = DOCS_TOC.find((d) => d.id === section)
  const perm = entry?.permission
  const hasAccess = usePermission(perm ?? '') || !perm

  if (!hasAccess) return null

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Документация"
        className="inline-flex items-center justify-center w-6 h-6 rounded-full text-text-muted hover:text-accent hover:bg-accent-soft/30 transition-colors"
      >
        <CircleHelp size={16} />
      </button>
      <DocDrawer section={section} open={open} onClose={() => setOpen(false)} />
    </>
  )
}

export function FloatingDocHint() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const section = ROUTE_MAP[location.pathname]
  const entry = section ? DOCS_TOC.find((d) => d.id === section) : undefined
  const perm = entry?.permission
  const hasAccess = usePermission(perm ?? '') || !perm

  if (!section || !hasAccess) return null

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Справка по текущей странице"
        className="fixed bottom-6 right-6 z-30 flex items-center justify-center w-10 h-10 rounded-full bg-accent text-white shadow-lg hover:bg-accent-hover transition-colors"
      >
        <CircleHelp size={20} />
      </button>
      <DocDrawer section={section} open={open} onClose={() => setOpen(false)} />
    </>
  )
}
